import { JetView } from 'webix-jet';

/**
 * Class representing the details view of a casino report.
 * @extends JetView
 */
export default class detailsCasinoReportView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Current screen size

        // Main information form configuration
        const main_info = {
            margin: 10,
            rows: [
                {
                    view: 'text', // Text input for ID
                    name: 'Id',
                    label: _("<span class='icon-id'></span> ID"),
                    labelPosition: 'top',
                    placeholder: _('Id'),
                    invalidMessage: _('A ID is required'), // Validation message
                    disabled: true, // Input is disabled
                },
                {
                    view: 'text', // Text input for Transaction ID
                    name: 'TransactionId',
                    label: _('Transacción Id'),
                    labelPosition: 'top',
                    placeholder: _('Transacción Id'),
                    disabled: true, // Input is disabled
                },
                {
                    view: 'text', // Text input for Type
                    name: 'Type',
                    label: _('Tipo'),
                    labelPosition: 'top',
                    placeholder: _('Tipo'),
                    disabled: true, // Input is disabled
                },
                {
                    view: 'text', // Text input for Value
                    name: 'Value',
                    label: _('Valor'),
                    labelPosition: 'top',
                    placeholder: _('Valor'),
                    disabled: true, // Input is disabled
                },
                {
                    view: 'text', // Text input for Response
                    name: 'Response',
                    label: _('Respuesta'),
                    labelPosition: 'top',
                    placeholder: _('Respuesta'),
                    disabled: true, // Input is disabled
                },
            ],
        };

        // Left main section configuration
        const left_main = {
            gravity: 3,
            minWidth: 200,
            margin: 10,
            rows: [main_info], // Contains the main_info form
        };

        // Upper section configuration for larger screens
        const upper_section = {
            multiview: true, // Allows multiple views
            scroll: true, // Enables scrolling
            cols: [left_main, { gravity: 1, minWidth: 20 }], // Layout columns
        };

        // Upper section configuration for narrow screens
        const upper_section_narrow = {
            cols: [
                {
                    gravity: 4,
                    margin: 10,
                    rows: [main_info], // Contains the main_info form
                },
            ],
        };

        // Return the main form configuration
        return {
            view: 'form',
            rows: [screen !== 'small' ? upper_section : upper_section_narrow], // Conditional layout based on screen size
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} form - The form instance to set values on.
     */
    init(form) {
        this.on(
            this.app,
            'casinoTransDetail:select',
            (
                person, // Event listener for selecting a transaction detail
            ) => form.setValues(person), // Sets the form values based on the selected person
        );
    }
}

// FILE DOCUMENTED
